// extracted by mini-css-extract-plugin
module.exports = {"button":"styles-module--button--2C-sA","button__disabled":"styles-module--button__disabled--3YIxg","spinner__wrapper":"styles-module--spinner__wrapper--14SDL"};